import { barCodes } from './config'

export function installBarX() {
  return Object.values(barCodes).map(info => {
    const { code, component } = info
    const name = `KyeReport${code}`
    return {
      name,
      extends: component,
      data() {
        return {
          code,
        }
      },
    }
  })
}




// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/echarts/bar-x/install.js